import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

/**
 * 生成接下来 n 天的日期列表
 */
export function generateNextDates(n, dateFormat = 'yyyy-MM-dd') {
  const dateList: {
    weekDayDesc: string
    dateDesc: string
  }[] = []
  const date = new Date()

  const WEEK_DAY = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

  for (let i = 0; i < n; i++) {
    // 获取未来日期的时间戳
    const timestamp = date.getTime() + i * 86400000
    // 转换为日期对象
    const d = new Date(timestamp)
    // 获取日期字符串，格式为 yyyy-MM-dd
    const o = {
      'y+': d.getFullYear(),
      'M+': d.getMonth() + 1, // month
      'd+': d.getDate(), // day
      'h+': d.getHours(), // hour
      'm+': d.getMinutes(), // minute
      's+': d.getSeconds(), // second
      S: d.getMilliseconds(), // millisecond
    }

    let dateFormatStr = dateFormat
    for (const k in o) {
      if (o.hasOwnProperty(k) && new RegExp('(' + k + ')').test(dateFormat)) {
        // dateFormat = dateFormat.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        const v = k === 'M+' || k === 'd+' ? paddingLeftZero(o[k]) : o[k]
        dateFormatStr = dateFormatStr.replace(new RegExp(`${k}`), v)
      }
    }
    // console.log('dateFormattttttttt', dateFormatStr);

    // 将日期字符串添加到数组中
    dateList.push({
      weekDayDesc: WEEK_DAY[d.getDay()],
      dateDesc: dateFormatStr,
    })
    // dates.push(dateString);
    // console.log(dateString);
  }

  return dateList
}

// 数字用0补全从边指定位数
export function paddingLeftZero(str, size = 2) {
  const zeros = new Array(size).fill(0).join('')
  return `${zeros}${str}`.slice(-size)
}

/**
 * 日期转为人性化描述
 * @param date
 */
export function getHumanizeDateText(date: dayjs.ConfigType) {
  const dayObj = dayjs(date)
  if (!dayObj.isValid()) return ''
  
  const todayObj = dayjs()
  if (dayObj.isSame(todayObj, 'day')) return '今天';
  if (dayObj.isSame(todayObj.add(1, 'day'), 'day')) return '明天';
  if (dayObj.isSame(todayObj.add(2, 'day'), 'day')) return '后天';

  return dayObj.locale('zh-cn').format('ddd')
}
